import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import API from "./api";
import icons_components from "./plugins/icons_components";
import VueScrollTo from "vue-scrollto";
import breakpoints from "./mixins/utils/Breakpoints.js";

Vue.use(VueScrollTo);

Vue.mixin(breakpoints);

API.setup();

Vue.config.productionTip = false;

for (const icon of icons_components) {
  Vue.component(icon.name, icon.component);
}

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
